import { ReelState } from "@nolimitcity/slot-game/bin/core/engines/reel/ReelEngineController";
import { TimeCheckPoints } from "@nolimitcity/slot-game/bin/core/utils/TimeCheckPoints";
import { StateHandler } from "@nolimitcity/slot-game/bin/core/utils/StateHandler";
import { Presentation } from "@nolimitcity/slot-game/bin/core/gamecontroller/presentations/Presentation";
import { SanEngineManager } from "../../engine/SanEngineManager";
import { RevealerManager } from "../independent/revealer/RevealerManager";
import { SoundManager } from "../../resource/sound/SoundManager";
import { GameConfig } from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import { XWaysCounter } from "../independent/countup/XWaysCounter";
import { SanEngineController } from "../../engine/SanEngineController";
import { ReelEvent } from "@nolimitcity/slot-game/bin/core/reel/event/ReelEvent";

import { EventHandler } from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import { GameEvent } from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import { SoundConfig } from "../../SoundConfig";
import { SanParsedInitData } from "../../server/data/SanParsedInitData";

/** Using a seperated StateHandler to ForceTrigg the presentation without it's internal StateSystem.
 * Reason is that the InternalState system is depended on the data that get's recieved from server.
 * So when we trigger a new BET, no data has been recieved yet, but we still want to play this. 
 */

/** 
*  Note that If you want any data to be parsed for this presentation, Use "CheckForActivation(data:any)".
*  But the data will mostly be parsed during or when the presentation have already started.
*  If you want to do some funnyStuff before the spin, Use the EndPresentation function and define the 
*  corresponding presentation to play something before this presentation starts.
*/
class ReelSpinStartState extends StateHandler {
    public static readonly START: string = "start";
    public static readonly DONE: string = "done";
}

export class ReelStartPresentation extends Presentation {

    protected state: ReelSpinStartState = new ReelSpinStartState(ReelSpinStartState.DONE);

    private soundStart:boolean = true;
    private isRestore:boolean = false;


    setParsedInitData(data:SanParsedInitData){
        this.isRestore = data.isRestoreState;
    }

    public isActive(): boolean {
        return !SanEngineManager.isPlaying && this.state.equal(ReelSpinStartState.DONE);
    }

    public checkForActivation(): boolean { return false; }

    public getPresentation(): void {
        if (this.state.equal(ReelSpinStartState.START)) return;

        this.normalStart();
        this.state.set(ReelSpinStartState.START);
    }

    public preStart(): void {

        if(this.isRestore){
            SanEngineManager.onBeforeSpinStart();
            this.isRestore = false;
        }
        
        // static readonly REEL_SPIN_STARTED: string;
        EventHandler.dispatchEvent(new GameEvent(ReelEvent.ALL_REELS_SPIN_STARTED));

        XWaysCounter.instance.setValue(undefined,243,0.45);
        TimeCheckPoints.setCheckPoint("Bet");
        
        this.soundStart = true;
        
        for (let reel = 0; reel < SanEngineManager.AllReels.length; reel++) {
            const RC:SanEngineController = SanEngineManager.getReel(reel);
            RC.changeAlpha(0,0.2);
            RC.createStart(false); 
        }
    }

    protected normalStart(): void {
        
        var delay: number = 0;
        var startDuration: number = 0;

        for (let reel = 0; reel < SanEngineManager.AllReels.length; reel++) {
            const rc:SanEngineController = SanEngineManager.getReel(reel);

            this.pTimeline.add([
                () => {
                    if(rc.isActive && this.soundStart) {
                        SoundManager.playSoundEffect(SoundConfig.instance.REELS_SPINNING,Number.MAX_SAFE_INTEGER);
                        this.soundStart = false;
                    }
                },
                () => rc.startReel(),
                () => rc.changeAlpha(0.2, rc.getStartDuration()),
                () => {
                    RevealerManager.getTopBar(rc.reelID).shuffle(true);
                    RevealerManager.getBotBar(rc.reelID).shuffle(true);
                },
                () => rc.AllSymbols.forEach(s => s.attentionDarkness(0,0.2)),
            ], delay);

            delay += rc.startDelay();

            // Get the longest StartTime to be added on the total delay between reels.
            if (rc.getPlayTime() > startDuration)
                startDuration = rc.getPlayTime();
            if(startDuration < GameConfig.instance.REEL_ENGINE_CONFIG!.DURATION.START) startDuration = GameConfig.instance.REEL_ENGINE_CONFIG!.DURATION.START;
        }

        this.pTimeline.add(() => EventHandler.dispatchEvent(new GameEvent(ReelEvent.ALL_REELS_SPIN_STARTED)),0);
        this.pTimeline.to(this, delay + startDuration, {});
    }

    // Checks if any reels are still starting.
    public promiseSync(): boolean {
        return SanEngineManager.findFirstReelWithState(ReelState.START) == -1;
    }


    public stopPresentation(): void {
        this.state.set(ReelSpinStartState.DONE);
        SanEngineManager.isPlaying = true;
    }
}